import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtherlocationaddressComponent } from './otherlocationaddress.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
      path: '',
      component: OtherlocationaddressComponent,
      data: {
          title: 'Other Location Address'
      }
  }
];

@NgModule({
  declarations: [OtherlocationaddressComponent],
  imports: [
      ReactiveFormsModule,
      FormsModule,
      MatSelectModule,
      CommonModule,
      RouterModule.forChild(routes)
  ],
  providers: [],
  exports: [RouterModule, OtherlocationaddressComponent],
})
export class OtherlocationaddressModule { }


